module.exports = __webpack_public_path__ + "img/15.7a912fae.png";